var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _circle3, _circle4, _circle5, _g, _g2, _g3, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartNothing = function SvgCartNothing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cartNothing_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M110.184 73.836c1.744 1.755 3.439 3.578 5.261 5.255 1.182 1.092 1.201 1.814 0 2.964-7.732 7.41-16.53 13.162-26.567 16.788-25.627 9.272-49.994 6.493-72.889-8.316-3.798-2.457-7.092-5.713-10.629-8.57-1.114-.906-1.153-1.628-.077-2.67 3.73-3.657 7.392-7.381 11.045-11.115.97-.975 1.638-1.102 2.723-.068 7.848 7.41 16.975 12.537 27.497 14.838 20.191 4.426 38.26-.088 53.986-13.668 2.732-2.36 2.693-2.399 5.222.126l4.418 4.446z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cartNothing_svg__b",
    width: 208,
    height: 114,
    x: -48,
    y: -9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M60.81 104.23c-25.07 0-43.704-12.197-48.786-16.94L-47.5 37.104 60.81-8.386l98.889 40L111 86.115c-17 14.5-40.363 18.114-50.19 18.114"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#cartNothing_svg__b)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3,
    cy: 10.3,
    r: 10.3,
    fill: "#F45149",
    transform: "matrix(-1 0 0 1 91.334 16.281)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80.676 22.106a1.57 1.57 0 0 1-1.151-.478 1.57 1.57 0 0 1-.479-1.151q0-.673.479-1.134a1.57 1.57 0 0 1 1.15-.478q.674 0 1.134.478.478.46.478 1.134 0 .672-.478 1.15a1.51 1.51 0 0 1-1.133.479m-1.329 11.333v-9.934H82.2v9.934z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D8DF",
    d: "M99.516 47.892 84.62 49.745l-6.118 36.463 1.674-.17 9.163-4.248a7.28 7.28 0 0 0 4.055-5.077z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2C9D4",
    d: "m84.624 49.744-58.515 1 6.396 35.96 45.771-.427a1.17 1.17 0 0 0 1.14-.997z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFE3E9",
    d: "m84.753 47.983.023 2.211.127-.001.126-.016zm14.428.41a2.212 2.212 0 1 0-.553-4.389zm-77.918.27.024 2.212 63.49-.68-.024-2.212-.024-2.212-63.49.68zm63.49-.68.276 2.194 14.152-1.784-.277-2.194-.276-2.195-14.152 1.784z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C7CDD6",
    strokeLinecap: "round",
    strokeWidth: 6.193,
    d: "m20.82 36.848 9.878 55.582a5.31 5.31 0 0 0 5.333 4.379l54.726-1.093"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6D9AE8",
    strokeLinecap: "round",
    strokeWidth: 6.133,
    d: "m10.253 36.355 10.514-2.322"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.646,
    cy: 101.147,
    r: 7.46,
    fill: "#C7CDD6",
    transform: "rotate(-15.104 38.646 101.147)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.646,
    cy: 101.147,
    r: 7.46,
    fill: "#C7CDD6",
    transform: "rotate(-15.104 71.646 101.147)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.644,
    cy: 101.242,
    r: 2.646,
    fill: "#DFE3E9",
    transform: "rotate(-15.104 38.644 101.242)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.643,
    cy: 101.242,
    r: 2.646,
    fill: "#DFE3E9",
    transform: "rotate(-15.104 71.643 101.242)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cartNothing_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.108,
    height: 21.233,
    fill: "#DFE3EA",
    rx: 3.554,
    transform: "matrix(.99487 -.10119 .12126 .99262 35.388 56.367)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cartNothing_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.419,
    height: 21.824,
    x: 52.059,
    y: 55.418,
    fill: "#DFE3EA",
    rx: 3.209,
    transform: "rotate(-1.144 52.06 55.418)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cartNothing_svg__e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.105,
    height: 21.242,
    fill: "#DFE3EA",
    rx: 3.552,
    transform: "matrix(.99695 .07806 -.10223 .99476 68.263 55.09)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EBF2",
    fillOpacity: 0.2,
    d: "m32.504 86.678-6.68-40.09 59.75-.907c.514 1.737.666 3.788-.886 4.296l-5.536 35.005a1.14 1.14 0 0 1-1.107.962l-25.05.427z",
    style: {
      mixBlendMode: "plus-darker"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231815",
    strokeMiterlimit: 10,
    strokeWidth: 0.513,
    d: "M55.687 23.117s-9.726 16.47-18.128 16.026-.342-11.55 4.939-7.123c5.28 4.426-1.412 17.59-9.498 19.876"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cartNothing_svg__c",
    width: 8.837,
    height: 21.113,
    x: 35.792,
    y: 55.988,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.28,
    dy: 1.14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.713726 0 0 0 0 0.741176 0 0 0 0 0.788235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_47639_121388"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cartNothing_svg__d",
    width: 6.727,
    height: 21.82,
    x: 52.123,
    y: 55.353,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.28,
    dy: 1.14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.713726 0 0 0 0 0.741176 0 0 0 0 0.788235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_47639_121388"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cartNothing_svg__e",
    width: 8.566,
    height: 21.154,
    x: 66.435,
    y: 55.355,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.28,
    dy: 1.14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.713726 0 0 0 0 0.741176 0 0 0 0 0.788235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_47639_121388"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cartNothing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgCartNothing;